<template>
  <footer class="footer">
    <div class="footer__content">
      <div class="footer__content__logo">
        <a href="/"><img :src="logo" alt="EDC"/></a>
      </div>
      <div class="footer__content__social">
        <div class="social">
          <a :href="linked_in_url"
            ><img :src="linked_in_icon" alt="Follow EDC on LinkedIn"
          /></a>
          <a :href="'mailto:' + mail_url"
            ><img :src="mail_icon" alt="Email EDC"
          /></a>
        </div>
        <div class="phone">
          <a :href="'tel:' + phone" v-html="phone"></a>
        </div>
      </div>
      <div class="footer__content__legal">
        <a class="footer__content__legal__child" :href="privacy_url"
          >Privacy Policy</a
        >
        <a class="footer__content__legal__child" :href="terms_url"
          >Terms & Conditions</a
        >
        <span>&copy; Copyright {{ getTheYear }} EDC Expert Group</span>
      </div>
      <div class="footer__content__address" v-html="address"></div>
      <div class="footer__content__logos">
        <ul v-if="parsedFooterLogos">
          <li
            v-for="(logo, index) in parsedFooterLogos.footer_logos"
            :key="index"
          >
            <img :src="logo.footer_logo.url" :alt="logo.footer_logo.alt" />
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    logo: {},
    linked_in_url: {},
    linked_in_icon: {},
    mail_url: {},
    mail_icon: {},
    phone: {},
    address: {},
    privacy_url: {},
    terms_url: {},
    footer_logos: {},
  },

  computed: {
    getTheYear() {
      var d = new Date();
      var n = d.getFullYear();
      return n;
    },

    parsedFooterLogos() {
      if (this.footer_logos) {
        return JSON.parse(this.footer_logos);
      } else {
        return null;
      }
    },
  },

  watch: {},

  methods: {},

  components: {},

  created() {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.footer {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 0;
  padding: 50px 0 100px;
  background: black;

  &__content {
    grid-column: 3 / span 8;
    display: grid;
    grid-template-columns: repeat(8, 1fr);
    color: white;
    column-gap: 50px;
    row-gap: 50px;

    @media (max-width: 1366px) {
      grid-template-columns: 1fr;
      grid-template-rows: 1fr;
      grid-column: 2 / span 10;
      row-gap: 25px;
    }

    &__logo {
      grid-column: span 4;
      a {
        img {
          width: 200px;
        }
      }
    }

    &__social {
      grid-column: span 4;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      align-items: flex-end;

      @media (max-width: 1366px) {
        align-items: flex-start;
      }

      .social {
        margin-bottom: 30px;
        display: flex;
        flex-direction: row;

        a {
          color: white;
          display: flex;
          flex-wrap: wrap;
          align-items: flex-start;
          margin-left: 25px;

          @media (max-width: 1366px) {
            margin-left: 0;
            margin-right: 25px;
          }

          img {
            height: 30px;
          }
        }
      }

      .phone {
        a {
          color: white;
          text-decoration: none;
          font-size: 1.5rem;

          img {
            height: 30px;
          }
        }
      }
    }

    &__legal {
      grid-column: span 5;
      text-align: left;
      display: flex;
      flex-direction: row;

      @media (max-width: 1366px) {
        flex-direction: column;
      }

      &__child {
        position: relative;
        display: flex;

        &::after {
          content: '|';
          margin: 0 20px;

          @media (max-width: 1366px) {
            display: none;
          }
        }
      }

      a {
        text-decoration: none;
        color: white;
      }
    }

    &__logos {
      grid-column: span 12;

      ul {
        list-style: none;
        display: flex;
        flex-direction: row;
				padding: 0;
				margin: 0;
				gap: 20px;

        li {
          img {
            height: 100px;
          }
        }
      }
    }

    &__address {
      grid-column: span 3;
      text-align: right;

      @media (max-width: 1366px) {
        text-align: left;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SiteFooter.vue